<template>
  <div id="app">
    <div class="app_list" v-show="isShow">
      <i class="el-icon-menu icon"></i>

      <div class="app_post">
        <p @click="indexClick()">首页监控</p>
        <!-- <div class="app_post_title" v-for="(item, index) in institutionsTree"
            :key="index">
          <p>{{item.menuName}}
            <i class="fr el-icon-arrow-right"></i>
          </p>
          <div class="app_post_list">
            <span v-for="(val, i) in item.list" :key="i">{{ val.menuName }}</span>
          </div>
        </div> -->
        <el-collapse accordion>
          <el-collapse-item
            :title="item.menuName"
            :name="index"
            v-for="(item, index) in institutionsTree"
            :key="index"
          >
            <div
              class="app_post_list"
              @click="listTab(index, i)"
              v-for="(val, i) in item.list"
              :key="i"
            >
              {{ val.menuName }}
            </div>
          </el-collapse-item>
        </el-collapse>
        <p @click="logout()">退出登录</p>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 菜单显示/隐藏
      isShow: true,

      // Tab菜单结构
      institutionsTree: [],
    };
  },
  watch: {
    // 监测路由变化
    $route(to, from) {
      // console.log(from);
      // console.log(from.path); //变化前
      // console.log(to.path); //变化后

      if (to.path == "/index" || to.path == "/login") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    // 监听VUEX菜单TAB
    "$store.state.institutionsTree"(newval, olval) {
      this.institutionsTree = newval;

      console.log(this.institutionsTree, "$store.state.institutionsTree");
    },
  },
  created() {
    if (
      window.location.href.split("#")[1] == "/index" ||
      window.location.href.split("#")[1] == "/login"
    ) {
      this.isShow = false;
    }
    // Tab菜单结构
    this.institutionsTree = JSON.parse(
      localStorage.getItem("institutionsTree")
    );
  },
  methods: {
    // 跳转TAB页面
    listTab(index, i) {
      let url = this.institutionsTree[index].list[i].txcode;
      let list = window.location.href.split("/");

      if (list[list.length - 1].toLowerCase() !== url.toLowerCase()) {
        this.$router.push({
          name: url,
        });
      }
    },
    // 首页监控跳转
    indexClick() {
      if (window.location.href.split("#")[1] == "/index") {
        return;
      }
      // 跳转首页监控
      this.$router.push("/index");
    },
    // 退出登录
    logout() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "Logout",
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            this.$message({
              type: "success",
              message: "退出登录",
            });
            // 清楚loginToken本地存储
            window.localStorage.removeItem("loginToken");
            // window.localStorage.clear();
            // 退出登录后跳转
            this.$router.push("/login");
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  // 页面卸载
  onunload() {
    // 退出登录
    this.logout();
  },
};
</script>

<style lang="less">
.app_list {
  position: fixed;
  bottom: 5%;
  right: 5%;
  border-radius: 50%;
  z-index: 999;
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  background-color: #fff;
  &:hover .icon {
    background-color: #545c64;
    color: #ffd04b;
  }
  &:hover .app_post {
    display: block;
    animation: myfirsts 1s;
    -moz-animation: myfirsts 1s forwards; /* Firefox */
    -webkit-animation: myfirsts 1s forwards; /* Safari and Chrome */
    -o-animation: myfirsts 1s forwards; /* Opera */
  }
  .icon {
    width: 50px;
    height: 50px;
    color: #666;
    font-size: 22px;
    line-height: 50px;
    border-radius: 50%;
    text-align: center;
    position: absolute;
    z-index: 999;
    &:hover {
      background-color: #545c64;
      cursor: pointer;
      animation: myfirst 1s;
      -moz-animation: myfirst 1s; /* Firefox */
      -webkit-animation: myfirst 1s; /* Safari and Chrome */
      -o-animation: myfirst 1s; /* Opera */
    }

    @keyframes myfirst {
      0% {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(-360deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }
  .app_post {
    margin: 0 25px 25px 0;
    width: 200px;
    overflow: hidden;
    display: none;
    position: absolute;
    bottom: 0px;
    right: 0px;
    z-index: 3;
    padding: 5px 5px;
    background-color: #545c64;
    @keyframes myfirsts {
      0% {
        // transform: rotate(0deg);
        width: 0;
      }
      100% {
        width: 200px;
        // transform: rotate(0deg);
      }
    }
    p {
      width: 100%;
      font-size: 14px;
      height: 46px;
      line-height: 46px;
      color: #fff;
      padding-left: 20px;
      box-sizing: border-box;
      background-color: #545c64;
      i {
        line-height: 46px;
        margin-right: 10px;
      }
      &:hover {
        color: #ffd04b;
        cursor: pointer;
        background-color: #434a50;
      }
    }
    .el-collapse-item__header {
      width: 100%;
      height: 48px;
      line-height: 48px;
      color: #fff;
      padding-left: 30px;
      box-sizing: border-box;
      background-color: #545c64;
      &:hover {
        color: #ffd04b;
        cursor: pointer;
        background-color: #434a50;
      }
    }
    .el-collapse-item__wrap .el-collapse-item__content {
      width: 100%;
      background-color: #545c64;
      padding-bottom: 10px;
      .app_post_list {
        height: 44px;
        text-align: center;
        line-height: 44px;
        color: #fff;
        // border-top: 1px solid rgb(141, 141, 141);
        &:hover {
          color: #ffd04b;
          cursor: pointer;
          background-color: #434a50;
        }
      }
    }
    // .app_post_list {
    //   color: #fff;
    //   text-align: center;
    //   line-height: 40px;
    //   border-top: 1px solid rgb(141, 141, 141);
    //   background-color: #545c64;
    // }
    // /deep/ .el-collapse {
    //   padding-left: 20px;
    //   box-sizing: border-box;
    //   color: #fff;
    //   background-color: #545c64;
    //   border-top: 1px solid rgb(141, 141, 141);
    // }
    // .app_post_list {
    //   color: #fff;
    //   text-align: center;
    //   line-height: 40px;
    //   background-color: #545c64;
    // }
    // /deep/ .el-collapse-item {
    //   width: 200px;
    //   background-color: #545c64;
    //   // padding-left: 15px;
    //   // box-sizing: border-box;
    //   .el-collapse-item__header {
    //     height: 48px;
    //     line-height: 48px;
    //     color: #fff;
    //     padding-left: 30px;
    //     box-sizing: border-box;
    //     background-color: #545c64;
    //     border-bottom: 1px solid rgb(141, 141, 141);
    //     &:hover {
    //       color: #ffd04b;
    //       cursor: pointer;
    //       background-color: #434a50;
    //     }
    //   }
    //   .el-collapse-item__wrap {
    //     background-color: #545c64;
    //     color: #fff;
    //     border-bottom: 1px solid rgb(141, 141, 141);
    //   }
    //   .el-collapse-item__wrap .el-collapse-item__content {
    //     // border-top: 1px solid rgb(141, 141, 141);
    //     padding-bottom: 0;
    //     text-align: center;
    //     line-height: 40px;
    //     color: #fff;
    //     // border-top: 1px solid rgb(182, 182, 182);
    //     background-color: #545c64;
    //     .app_post_list {
    //       background-color: #545c64;
    //       // border-top: 1px solid rgb(141, 141, 141);
    //       color: #fff;
    //       &:hover {
    //         color: #ffd04b;
    //         cursor: pointer;
    //         background-color: #434a50;
    //       }
    //     }
    //   }
    // }
    // // .el-collapse-item {
    // //   width: 200px;
    // //   // padding-left: 15px;
    // //   // box-sizing: border-box;
    // .el-collapse-item {

    //   width: 200px;
    //   color: #fff;
    //   background-color: #545c64;
    //   /deep/ .el-collapse-item__header {
    //     height: 48px;
    //     line-height: 48px;
    //     color: #fff;
    //     padding-left: 20px;
    //     box-sizing: border-box;
    //     background-color: #545c64;
    //     border-bottom: 1px solid rgb(141, 141, 141);
    //     &:hover {
    //       color: #ffd04b;
    //       cursor: pointer;
    //       background-color: #434a50;
    //     }
    //   }
    //   /deep/ .el-collapse-item__header is-active {
    //     height: 48px;
    //     line-height: 48px;
    //     color: #fff;
    //     padding-left: 30px;
    //     box-sizing: border-box;
    //     background-color: #545c64;
    //     border-bottom: 1px solid rgb(141, 141, 141);
    //     &:hover {
    //       color: #ffd04b;
    //       cursor: pointer;
    //       background-color: #434a50;
    //     }
    //   }
    // }
    // //   .el-collapse-item__wrap {
    // //     border-bottom: 1px solid rgb(141, 141, 141);
    // //   }
    // //   .el-collapse-item__wrap .el-collapse-item__content {
    // //     // border-top: 1px solid rgb(141, 141, 141);
    // //     padding-bottom: 0;
    // //     text-align: center;
    // //     line-height: 40px;
    // //     color: #fff;
    // //     // border-top: 1px solid rgb(182, 182, 182);
    // //     background-color: #545c64;
    // //     .app_post_list {
    // //       &:hover {
    // //         color: #ffd04b;
    // //         cursor: pointer;
    // //         background-color: #434a50;
    // //       }
    // //     }
    // //   }
    // // }
  }
}

* {
  margin: 0;
  padding: 0;
}
.clearfix::after {
  clear: both;
  display: block;
  content: "";
}
.fl {
  float: left;
}
.fr {
  float: right;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 16px;
  font-weight: normal;
}
input,
textarea {
  border: none;
  outline: none;
}
img {
  display: block;
}
button {
  border: none;
  background-color: transparent;
}

// 浏览器滚动条样式
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  --webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgb(220, 220, 220);
  --webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);
}

::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(220, 220, 220, 0.4);
}
</style>
